import { Box, Stack } from "@mui/material";
import mhlImage1 from "src/assets/mhl-img-1.png";

const MhlImage = () => {
  return (
    <Stack alignItems={"center"}>
      <Box component={"img"} src={mhlImage1} width={"60%"} />
    </Stack>
  );
};

export default MhlImage;
